import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from "i18next";
import {useTranslation} from "react-i18next";

interface LanguageSelectorProps {
  isOpen: boolean;
  onClose: () => void;
}
const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [productsMenuOpen, setProductsMenuOpen] = useState(false);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const productsMenuRef = useRef<HTMLDivElement>(null);
  const productsButtonRef = useRef<HTMLButtonElement>(null);
  const languageMenuRef = useRef<HTMLDivElement>(null);

  type Language = {
    code: string;
    name: string;
    flag: string;
  };


  const languages: Language[] = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    // { code: 'kz', name: 'Қазақ', flag: '🇰🇿' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    // { code: 'gr', name: 'Ελληνικά', flag: '🇬🇷' },
    { code: 'ua', name: 'Українська', flag: '🇺🇦' }
  ];


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
          productsMenuRef.current &&
          !productsMenuRef.current.contains(event.target as Node) &&
          productsButtonRef.current &&
          !productsButtonRef.current.contains(event.target as Node)
      ) {
        setProductsMenuOpen(false);
      }
      if (
          languageMenuRef.current &&
          !languageMenuRef.current.contains(event.target as Node)
      ) {
        setLanguageMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleProductsMenu = () => {
    setProductsMenuOpen(!productsMenuOpen);
  };

  const toggleLanguageMenu = () => {
    setLanguageMenuOpen(!languageMenuOpen);
  };

  const loginToMiniapp = () => {
    setMobileMenuOpen(false);
    window.location.href = "https://account.kirenagainvest.com/login";
  };

  const registerToMiniapp = () => {
    setMobileMenuOpen(false);
    window.location.href = "https://account.kirenagainvest.com/registration"
  };

  const changeLanguage = (lang: string) => {
    console.log(`Language changed to: ${lang}`);
    setLanguageMenuOpen(false);
    // Здесь вы можете добавить изменение языка через i18n или любую другую библиотеку
  };
  const handleLanguageSelect = (code: string) => {
    i18n.changeLanguage(code);
    setLanguageMenuOpen(false); // Закрываем меню
    console.log(`Selected language: ${code}`);
  };
  const { t } = useTranslation() as {
    t: (key: string, options?: any) => string;
  };

  return (
      <>
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 
        ${isScrolled ? 'bg-white bg-opacity-90 py-2 shadow-lg' : 'bg-white py-4'}`}
        >
          <div className="px-4">
            <div className="flex justify-between items-center">
              <a href="/">
                <div className="flex items-center">
                  <img
                      src={require('../../assets/images/logo.png')}
                      alt="Liberty Investment Kirenaga Logo"
                      className="w-10 h-10 mr-2"
                  />
                  <span className="font-bold font-druk text-2xl">LIK</span>
                </div>
              </a>

              <nav className="hidden md:flex text-2xl space-x-6 ">
                <a href="/about" className="hover:text-[#BCDE02] transition-colors">{t('about')}</a>
                <div className="relative">
                  <button
                      ref={productsButtonRef}
                      className="hover:text-[#BCDE02] transition-colors focus:outline-none"
                      onClick={toggleProductsMenu}
                  >
                    {t('products')}
                    <span className="ml-1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="inline-block"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                  </button>

                  {productsMenuOpen && (
                      <div
                          ref={productsMenuRef}
                          className="absolute z-10 mt-2 w-48 rounded-md shadow-lg bg-white border border-[#BCDE02]"
                          style={{ borderRadius: '8px', overflow: 'hidden' }}
                      >
                        <div className="py-0 text-xl divide-y divide-[#BCDE02]">
                          <a href="/#trading" className="block px-4 py-3 hover:bg-gray-50 font-bold border-t border-[#BCDE02]">TRADING</a>
                          <a href="/#staking" className="block px-4 py-3 hover:bg-gray-50 font-bold border-t border-[#BCDE02]">STAKING</a>
                          <a href="/#thorchain" className="block px-4 py-3 hover:bg-gray-50 font-bold border-t border-[#BCDE02]">THORCHAIN</a>
                          <a href="/#cannabis" className="block px-4 py-3 hover:bg-gray-50 font-bold border-t border-[#BCDE02]">CANNABIS</a>
                          <a href="/#casino" className="block px-4 py-3 hover:bg-gray-50 font-bold border-t border-[#BCDE02]">CASINO</a>
                        </div>
                      </div>
                  )}
                </div>
                <a href="#contacts" className="hover:text-[#BCDE02] transition-colors">{t('contacts')}</a>
              </nav>

              <div className="flex text-xl items-center space-x-3 md:space-x-4">
                
                <a href="https://t.me/lik_invest_bot" className="hidden md:flex hover:text-[#BCDE02]">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="#BCDE02"
                      className="w-12 h-12"
                  >
                    <path
                        d="M9.78,18.65L10.06,14.37L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"/>
                  </svg>
                </a>


                {/* Глобус с языками */}
                <div className="relative flex items-center justify-center" ref={languageMenuRef}>
                  <button onClick={toggleLanguageMenu} className="hover:text-[#BCDE02]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-7 h-7 md:w-8 md:h-8"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="2" y1="12" x2="22" y2="12"></line>
                      <path
                          d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                  </button>

                  {languageMenuOpen && (
                      <div
                          className="absolute right-0 mt-2 bg-white border border-gray-300 shadow-md rounded-lg text-sm z-50 w-40" style={{top: '20px'}}>
                        {languages.map((language) => (
                            <button
                                key={language.code}
                                onClick={() => handleLanguageSelect(language.code)}
                                className="flex items-center w-full text-left px-4 py-2 hover:bg-gray-100"
                            >
                              <span className="mr-2">{language.flag}</span> {language.name}
                            </button>
                        ))}
                      </div>
                  )}
                  <a onClick={() => loginToMiniapp()} className="hidden md:flex hover:text-[#BCDE02] text-2xl px-6 cursor-pointer">
                    {t("login")}
                    </a>
                </div>

                <button className="md:hidden shadow-none" onClick={toggleMobileMenu}>
                  {mobileMenuOpen ? (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                  ) : (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
                      </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Мобильное меню */}
        {mobileMenuOpen && (
            <div className="fixed inset-0 z-40 bg-white pt-20 md:hidden">
              <div className="container mx-auto px-4">
                <nav className="flex flex-col space-y-6 text-xl py-8 ">
                  <a href="/about"
                     className="hover:text-[#BCDE02] transition-colors border-b border-gray-800 pb-3 font-druk"
                     onClick={() => setMobileMenuOpen(false)}>{t('about')}</a>
                  <div className="border-b border-gray-800 pb-3">
                    <p className="mb-2 font-druk">{t('products')}</p>
                    <div className="pl-4 flex flex-col space-y-3 mt-3 font-druk">
                      <a href="/#trading" className="hover:text-[#BCDE02]"
                         onClick={() => setMobileMenuOpen(false)}>TRADING</a>
                      <a href="/#staking" className="hover:text-[#BCDE02]"
                         onClick={() => setMobileMenuOpen(false)}>STAKING</a>
                      <a href="/#thorchain" className="hover:text-[#BCDE02]"
                         onClick={() => setMobileMenuOpen(false)}>THORCHAIN</a>
                      <a href="/#cannabis" className="hover:text-[#BCDE02]"
                         onClick={() => setMobileMenuOpen(false)}>CANNABIS</a>
                      <a href="/#casino" className="hover:text-[#BCDE02]"
                         onClick={() => setMobileMenuOpen(false)}>CASINO</a>
                    </div>
                  </div>
                  <div className="border-b border-gray-800 pb-3">
                    <div className="pl-4 flex flex-col space-y-3 mt-3 font-druk">
                      <a href="#contacts" className="hover:text-[#BCDE02] transition-colors pb-3 font-druk"
                         onClick={() => setMobileMenuOpen(false)}>{t('contacts')}</a>
                    </div>
                  </div>
                  <div className="pl-4 flex flex-col space-y-3 mt-3 font-druk">
                    <a href="#login" className="hover:text-[#BCDE02] transition-colors pb-3 font-druk block"
                       onClick={() => loginToMiniapp()}>{t('login')}</a>
                    <a href="#login" className="hover:text-[#BCDE02] transition-colors pb-3 font-druk block"
                       onClick={() => registerToMiniapp()}>{t('registration')}</a>
                  </div>
                </nav>
              </div>
            </div>
        )}
      </>
  );
};

export default Header;